import TimeSlots from './TimeSlots.jsx';
import './TimeSlots.css';

export default TimeSlots;
